import { IconFont, Input } from '@byecode/ui'
import styled from 'styled-components'

export const SearchIcon = styled(IconFont)`
    width: 16px;
    margin-right: 4px;
`

export const SearchInput = styled(Input)<{ color: string }>`
    :focus-within {
        border-color: ${({ color }) => color};
    }
`
